import { useState } from "react";
import NavBarButtom from "./NavBarButtom";
import ChatSessions from "./ChatSessions";
import { useChatHistory } from "../../ChatHistoryProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faPlus } from "@fortawesome/free-solid-svg-icons";

const NavBar = () => {
  const { newChat } = useChatHistory();
  const [openNav, setOpenNav] = useState(false);

  const handleNavButtonClick = () => {
    setOpenNav(!openNav);
  };

  const handleNavClose = () => {
    setOpenNav(false);
  };

  return (
    <>
      <div className="fixed z-10 flex items-center pl-2 pt-2 text-gray-200 sm:pl-4 md:hidden w-full">
        <button
          type="button"
          onClick={handleNavButtonClick}
          className="flex items-center justify-center p-3 rounded-md dark:bg-gray-300 bg-gray-900 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white dark:hover:text-white"
        >
          <FontAwesomeIcon icon={faBars} className="dark:text-gray-900" />
        </button>
      </div>
      {openNav && (
        <>
          <div
            className="fixed top-0 left-0 z-10 w-screen h-screen bg-gray-100 opacity-50 md:hidden"
            onClick={handleNavClose}
          />
          <div className="absolute top-0 right-0 z-10 bg-gray-800 dark:bg-gray-900 md:hidden">
            <button
              className="text-white w-full text-right p-3"
              onClick={handleNavClose}
            >
              X
            </button>
          </div>
        </>
      )}
      <div
        className={`${
          openNav ? "relative w-64" : "hidden"
        } z-10 bg-gray-800 dark:bg-gray-900 md:flex md:w-[260px] md:flex-col`}
      >
        <nav className="flex flex-col flex-grow p-2">
            <img src="./big-logo.png" alt="PrescribeFit" className="p-1 mb-2"></img>
          <a
            onClick={newChat}
            className="flex py-2 px-4 items-center gap-3 rounded-md hover:bg-gray-500/10 transition-colors duration-200 text-white cursor-pointer text-sm mb-1 flex-shrink-0 border border-white/20"
          >
            <FontAwesomeIcon icon={faPlus} /> New Chat
          </a>
          <div className="flex-col flex-1 transition-opacity duration-500 overflow-y-auto border-b border-white/20">
            <div className="flex flex-col gap-2 pb-2 text-gray-100 text-sm h-fit max-h-96">
              <ChatSessions />
            </div>
          </div>
          <div className="mt-auto">
            <NavBarButtom />
          </div>
        </nav>
      </div>
    </>
  );
};

export default NavBar;
